import React from 'react';

// GoogleIcon and AppleIcon remain the same
export const GoogleIcon = (props) => {
  const { size = 24, ...rest } = props;
  return (
    <img
      src="https://firebasestorage.googleapis.com/v0/b/boutee-app.firebasestorage.app/o/CustomerApp%2FIcons%2FGoogle__G__logo.svg?alt=media&token=bf1c666d-9dc1-47e6-a4c6-a71c7a2c774f"
      alt="Google"
      width={size}
      height={size}
      style={{ display: 'block' }}
      {...rest}
    />
  );
};

export const AppleIcon = (props) => {
  const { size = 24, ...rest } = props;
  return (
    <img
      src="https://firebasestorage.googleapis.com/v0/b/boutee-app.firebasestorage.app/o/CustomerApp%2FIcons%2F32px-Apple_logo_black.svg.png?alt=media&token=34f07326-351f-4b8e-91ae-20149342fdb2"
      alt="Apple"
      height={size}
      style={{
        display: 'block',
        width: 'auto',
        height: `${size}px`
      }}
      {...rest}
    />
  );
};

// Pinterest Black Icon (default)
export const PinterestIcon = (props) => {
  const { size = 24, ...rest } = props;
  return (
    <img
      src="https://firebasestorage.googleapis.com/v0/b/boutee-app.firebasestorage.app/o/CustomerApp%2FIcons%2FPinterest%20Logo%20Black.png?alt=media&token=2edbd706-bb93-466b-b2d6-2501250601ef"
      alt="Pinterest"
      width={size}
      height={size}
      style={{ display: 'block' }}
      {...rest}
    />
  );
};

// Pinterest Red Icon
export const PinterestRedIcon = (props) => {
  const { size = 24, ...rest } = props;
  return (
    <img
      src="https://firebasestorage.googleapis.com/v0/b/boutee-app.firebasestorage.app/o/CustomerApp%2FIcons%2FPinterest%20Logo%20Red.png?alt=media&token=a938a015-18e1-45ab-9d38-bc6ce0e024ae"
      alt="Pinterest"
      width={size}
      height={size}
      style={{ display: 'block' }}
      {...rest}
    />
  );
};

// Pinterest White Icon
export const PinterestWhiteIcon = (props) => {
  const { size = 24, ...rest } = props;
  return (
    <img
      src="https://firebasestorage.googleapis.com/v0/b/boutee-app.firebasestorage.app/o/CustomerApp%2FIcons%2FPinterest%20Logo%20White.webp?alt=media&token=c65f91dd-cf6f-4ac0-8efd-e6f6a9e047e4"
      alt="Pinterest"
      width={size}
      height={size}
      style={{ display: 'block' }}
      {...rest}
    />
  );
};

export const MyRingsIcon = (props) => {
  const { size, ...rest } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
      width={size}
      height={size}
      {...rest}
    >
      <path d="M10.24 6.5a2.5 2.5 0 0 0 -3.48 3.48" />
      <path d="M13.76 17.5a2.5 2.5 0 0 0 3.48 -3.48" />
      <path d="M10.24 17.5a2.5 2.5 0 0 1 -3.48 -3.48" />
      <path d="M13.76 6.5a2.5 2.5 0 0 1 3.48 3.48" />
      <path d="M8.5 15.75a2.5 2.5 0 0 0 0 -7.5" />
      <path d="M15.5 8.25a2.5 2.5 0 0 0 0 7.5" />
      <path d="M10.25 8.5a2.5 2.5 0 0 1 3.5 0" />
      <path d="M13.75 15.5a2.5 2.5 0 0 1 -3.5 0" />
    </svg>
  );
};

export const InfoIconGuide = (props) => {
  const { size, ...rest } = props;
  const iconUrl = "https://firebasestorage.googleapis.com/v0/b/boutee-app.firebasestorage.app/o/CustomerApp%2FIcons%2FInfo.svg?alt=media&token=b0d06b83-8598-4a31-9bdd-dc3a6e4f7365";

  return (
    <img
      src={iconUrl}
      alt="Info"
      width={size}
      height={size}
      {...rest}
    />
  );
};

export const LocationIcon = (props) => {
  const { size, ...rest } = props;
  const iconUrl = "https://firebasestorage.googleapis.com/v0/b/boutee-app.firebasestorage.app/o/CustomerApp%2FIcons%2FLocation.svg?alt=media&token=cd310c6b-f797-4b87-95a7-9f2a48733470";

  return (
    <img
      src={iconUrl}
      alt="Location"
      width={size}
      height={size}
      {...rest}
    />
  );
};

export const InfoGreyIcon = (props) => {
  const { size, ...rest } = props;
  const iconUrl = "https://firebasestorage.googleapis.com/v0/b/boutee-app.firebasestorage.app/o/CustomerApp%2FIcons%2FInfo%20Grey.svg?alt=media&token=dc566b6e-2569-42b3-a931-a729f93cd353";
  return <img src={iconUrl} alt="Info" width={size} height={size} {...rest} />;
};

export const SortIcon = (props) => {
  const { size, ...rest } = props;
  const iconUrl = "https://firebasestorage.googleapis.com/v0/b/boutee-app.firebasestorage.app/o/CustomerApp%2FIcons%2FSorting.svg?alt=media&token=16813515-4ee3-4a53-9755-d18adea60d51";
  return <img src={iconUrl} alt="Sort" width={size} height={size} {...rest} />;
};

export const FilterIcon = (props) => {
  const { size, ...rest } = props;
  const iconUrl = "https://firebasestorage.googleapis.com/v0/b/boutee-app.firebasestorage.app/o/CustomerApp%2FIcons%2FFilter.svg?alt=media&token=f3044386-78de-45aa-ba7f-48741c3c0698";
  return <img src={iconUrl} alt="Filter" width={size} height={size} {...rest} />;
};

export const PlayIconGradient = (props) => {
  const { size, ...rest } = props;
  const iconUrl = "https://firebasestorage.googleapis.com/v0/b/boutee-app.firebasestorage.app/o/CustomerApp%2FIcons%2FPlay%20filled.svg?alt=media&token=b4dfac24-8c2e-42c5-acc6-1c97ca3478a8";
  return <img src={iconUrl} alt="Play" width={size} height={size} {...rest} />;
};

// Company Logo Icon (adapts to current color)
export const CompanyLogoIcon = (props) => {
  const { size, ...rest } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 161.23 161.23"
      fill="currentColor"
      width={size}
      height={size}
      {...rest}
    >
      <path d="M125.26,125.26c5.33,1.46,10.76,1.39,15.91-.23,7.2-2.27,16.06-9,19.06-17.48,1.75-4.94,1.2-9.79-1.59-14.01-2.41-3.65-5.22-5.66-8.34-5.96-5.9-.57-11.33,4.96-16.11,9.83-1.75,1.79-3.41,3.47-4.87,4.63-8.09,6.37-14.31,3.75-20.87-2.81l-18.6-18.6,18.28-18.27c6.6-6.89,12.98-9.62,21.2-3.15,1.46,1.15,3.12,2.84,4.87,4.63,4.78,4.87,10.21,10.4,16.11,9.83,3.12-.3,5.93-2.31,8.34-5.96,2.79-4.22,3.34-9.07,1.59-14.01-3.01-8.48-11.87-15.21-19.06-17.48-5.15-1.62-10.58-1.69-15.91-.23,1.46-5.33,1.39-10.76-.23-15.91-2.27-7.2-9.01-16.06-17.48-19.06-4.94-1.75-9.79-1.2-14.01,1.59-3.65,2.41-5.66,5.22-5.96,8.34-.57,5.9,4.96,11.33,9.83,16.11,1.79,1.76,3.48,3.41,4.63,4.87,6.47,8.22,3.75,14.6-3.15,21.2l-18.27,18.28-19.19-19.21c-5.96-6.47-8.34-12.49-2.22-20.26,1.15-1.46,2.84-3.12,4.63-4.87,4.87-4.79,10.4-10.21,9.83-16.11-.3-3.12-2.3-5.93-5.96-8.34-4.22-2.79-9.07-3.34-14.01-1.59-8.48,3.01-15.21,11.87-17.48,19.06-1.62,5.15-1.69,10.58-.23,15.91-5.32-1.46-10.76-1.39-15.91.23-7.2,2.27-16.06,9-19.06,17.48-1.75,4.94-1.2,9.79,1.59,14.01,2.41,3.65,5.22,5.66,8.34,5.96,5.9.57,11.33-4.96,16.11-9.83,1.75-1.79,3.41-3.48,4.87-4.63,7.79-6.13,15.06-4.97,21.53,1.02l19.19,19.16c-10.69,10.7-20.45,20.43-20.45,20.43-6.47,5.96-12.49,8.34-20.26,2.23-1.46-1.15-3.12-2.84-4.87-4.63-4.79-4.87-10.21-10.4-16.11-9.83-3.12.3-5.93,2.31-8.34,5.96-2.79,4.22-3.34,9.07-1.59,14.01,3.01,8.48,11.86,15.21,19.06,17.48,5.15,1.62,10.58,1.69,15.91.23-1.46,5.33-1.39,10.76.23,15.91,1.33,4.22,4.19,9,8.04,12.85,2.72,2.72,5.93,4.97,9.45,6.22,4.94,1.75,9.79,1.2,14.01-1.59,3.65-2.41,5.66-5.22,5.96-8.34.57-5.9-4.96-11.33-9.83-16.11-1.79-1.75-3.48-3.41-4.63-4.87-6.13-7.79-3.74-13.82,2.25-20.29,0,0,9.75-9.78,20.4-20.42l18.61,18.61c6.56,6.56,7.94,14.02,1.57,22.11-1.15,1.46-2.84,3.12-4.63,4.87-4.87,4.79-10.4,10.21-9.83,16.11.21,2.17,1.24,4.19,3.09,6.03.8.8,1.76,1.57,2.87,2.31,4.22,2.79,9.07,3.34,14.01,1.59,8.48-3.01,15.21-11.87,17.48-19.06,1.62-5.15,1.69-10.58.23-15.91Z"/>
    </svg>
  );
};

// Company Logo Icon (always white)
export const CompanyLogoWhiteIcon = (props) => {
  const { size, ...rest } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 161.23 161.23"
      fill="#fff"
      width={size}
      height={size}
      {...rest}
    >
      <path d="M125.26,125.26c5.33,1.46,10.76,1.39,15.91-.23,7.2-2.27,16.06-9,19.06-17.48,1.75-4.94,1.2-9.79-1.59-14.01-2.41-3.65-5.22-5.66-8.34-5.96-5.9-.57-11.33,4.96-16.11,9.83-1.75,1.79-3.41,3.47-4.87,4.63-8.09,6.37-14.31,3.75-20.87-2.81l-18.6-18.6,18.28-18.27c6.6-6.89,12.98-9.62,21.2-3.15,1.46,1.15,3.12,2.84,4.87,4.63,4.78,4.87,10.21,10.4,16.11,9.83,3.12-.3,5.93-2.31,8.34-5.96,2.79-4.22,3.34-9.07,1.59-14.01-3.01-8.48-11.87-15.21-19.06-17.48-5.15-1.62-10.58-1.69-15.91-.23,1.46-5.33,1.39-10.76-.23-15.91-2.27-7.2-9.01-16.06-17.48-19.06-4.94-1.75-9.79-1.2-14.01,1.59-3.65,2.41-5.66,5.22-5.96,8.34-.57,5.9,4.96,11.33,9.83,16.11,1.79,1.76,3.48,3.41,4.63,4.87,6.47,8.22,3.75,14.6-3.15,21.2l-18.27,18.28-19.19-19.21c-5.96-6.47-8.34-12.49-2.22-20.26,1.15-1.46,2.84-3.12,4.63-4.87,4.87-4.79,10.4-10.21,9.83-16.11-.3-3.12-2.3-5.93-5.96-8.34-4.22-2.79-9.07-3.34-14.01-1.59-8.48,3.01-15.21,11.87-17.48,19.06-1.62,5.15-1.69,10.58-.23,15.91-5.32-1.46-10.76-1.39-15.91.23-7.2,2.27-16.06,9-19.06,17.48-1.75,4.94-1.2,9.79,1.59,14.01,2.41,3.65,5.22,5.66,8.34,5.96,5.9.57,11.33-4.96,16.11-9.83,1.75-1.79,3.41-3.48,4.87-4.63,7.79-6.13,15.06-4.97,21.53,1.02l19.19,19.16c-10.69,10.7-20.45,20.43-20.45,20.43-6.47,5.96-12.49,8.34-20.26,2.23-1.46-1.15-3.12-2.84-4.87-4.63-4.79-4.87-10.21-10.4-16.11-9.83-3.12.3-5.93,2.31-8.34,5.96-2.79,4.22-3.34,9.07-1.59,14.01,3.01,8.48,11.86,15.21,19.06,17.48,5.15,1.62,10.58,1.69,15.91.23-1.46,5.33-1.39,10.76.23,15.91,1.33,4.22,4.19,9,8.04,12.85,2.72,2.72,5.93,4.97,9.45,6.22,4.94,1.75,9.79,1.2,14.01-1.59,3.65-2.41,5.66-5.22,5.96-8.34.57-5.9-4.96-11.33-9.83-16.11-1.79-1.75-3.48-3.41-4.63-4.87-6.13-7.79-3.74-13.82,2.25-20.29,0,0,9.75-9.78,20.4-20.42l18.61,18.61c6.56,6.56,7.94,14.02,1.57,22.11-1.15,1.46-2.84,3.12-4.63,4.87-4.87,4.79-10.4,10.21-9.83,16.11.21,2.17,1.24,4.19,3.09,6.03.8.8,1.76,1.57,2.87,2.31,4.22,2.79,9.07,3.34,14.01,1.59,8.48-3.01,15.21-11.87,17.48-19.06,1.62-5.15,1.69-10.58.23-15.91Z"/>
    </svg>
  );
};